import { Suspense } from 'react'
import { Links, Meta, Outlet, Scripts, ScrollRestoration } from 'react-router'
import { AppProviders } from 'components'
import { ThemeProvider } from 'components/theme-provider'
import { TooltipProvider } from '@trinity/ui/components/tooltip'
import { Empty, EmptyHeader } from '@trinity/ui/components/empty'

export function Layout({ children }: { children: React.ReactNode }) {
  return (
    <html lang='en'>
      <head>
        <meta charSet='UTF-8' />
        <meta name='viewport' content='width=device-width, initial-scale=1, maximum-scale=1, shrink-to-fit=no' />
        <Meta />
        <Links />
      </head>
      <body>
        <TooltipProvider>{children}</TooltipProvider>
        <ScrollRestoration />
        <Scripts />
      </body>
    </html>
  )
}

export function HydrateFallback() {
  return (
    <ThemeProvider defaultTheme='dark' storageKey='vite-ui-theme'>
      <Empty>
        <EmptyHeader>Loading...</EmptyHeader>
      </Empty>
    </ThemeProvider>
  )
}

export default function Root() {
  return (
    <AppProviders>
      <Suspense
        fallback={
          <Empty>
            <EmptyHeader>Loading...</EmptyHeader>
          </Empty>
        }
      >
        <Outlet />
      </Suspense>
    </AppProviders>
  )
}

export function ErrorBoundary() {
  return <h1>Ruh roh raggy</h1>
}
